@if (initialized && activeNavigationItem) {
    <div class="config-content-container surface-0">
        @if (activeNavigationItem?.action === 'jobTypes' || !activeNavigationItem) {
            @if (jbJobTypeWidget) {
                <mvs-widget
                    [widgetData]="jbJobTypeWidget"
                    (onObjectSelect)="handleEntitySelect($event)"
                ></mvs-widget>
            }
        }
        @if (activeNavigationItem?.action === 'runLog') {
            @if (jbJobRunLogWidget) {
                <mvs-widget
                    [widgetData]="jbJobRunLogWidget"
                    (onObjectSelect)="handleEntitySelect($event)"
                ></mvs-widget>
            }
        }
    </div>
}
